import { createFileRoute, Link } from '@tanstack/react-router';
import { SlidersHorizontal } from 'lucide-react';

import { getRecentLikersOptions } from '@/features/likes/hooks/useGetRecentLikers/useGetRecentLikers.options';
import { getProfileOptions } from '@/features/profile/hooks/useGetProfile';
import { Recommendations } from '@/features/recommend/components/recommendations';
import { PREFETCH_CARD_COUNT } from '@/features/recommend/constants/prefetch';
import { getRecommendedPlayersOptions } from '@/features/recommend/hooks/useGetRecommendedPlayers';
import { getBalanceOptions } from '@/features/subscription/hooks/useGetBalance/getBalance.options';
import { MainLayout } from '@/shared/components/mainLayout';
import { PageHeader } from '@/shared/components/pageHeader';

export const Route = createFileRoute('/_protected/_app/_mainLayout/')({
  beforeLoad: async ({ context }) => {
    // 4. Prefetch balance
    void context.queryClient.prefetchQuery(getBalanceOptions());
  },
  component: RouteComponent,
  loader: async ({ context }) => {
    // 1. Fetch recommendation IDs
    const userIds = await context.queryClient.ensureQueryData(
      getRecommendedPlayersOptions(),
    );

    // 2. Prefetch first N user profiles and recent likers in parallel
    const firstProfiles = userIds.slice(0, PREFETCH_CARD_COUNT);
    await Promise.all([
      Promise.allSettled(
        firstProfiles.map(userId =>
          context.queryClient.ensureQueryData(getProfileOptions({ userId })),
        ),
      ),
      // 3. Prefetch recent likers
      context.queryClient.ensureQueryData(getRecentLikersOptions()),
    ]);
  },
});

function RouteComponent() {
  return (
    <MainLayout.Root>
      <PageHeader.Root>
        <PageHeader.Gankster />
        <PageHeader.PlayNowToggle />
        <div className="flex items-center gap-2">
          <Link to="/filters" className="text-cold-200 p-1">
            <SlidersHorizontal className="size-6" />
          </Link>
          <PageHeader.NonToxicBadge />
        </div>
      </PageHeader.Root>
      <MainLayout.Content className="flex min-h-0 flex-col">
        <Recommendations />
      </MainLayout.Content>
    </MainLayout.Root>
  );
}
